import React from 'react';

import { faFacebookF, faLinkedinIn, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { css, styled } from 'styled-components';

const ShareContainer = styled.div``;

const Share = styled.div`
  font-family: ${(props) => props.theme.fonts.fontFamilySecondary};
  text-transform: uppercase;
  font-size: 0.875rem;
  margin-bottom: 1rem;
`;

const IconContainer = styled.span(
  ({ theme }) => css`
    border-radius: 50%;
    font-size: 0.875rem;
    width: 2.25rem;
    height: 2.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 250ms ease-in-out;

    &:hover {
      background-color: ${theme.colors.iconHoverGray};
    }
  `
);

const Links = styled.div`
  display: flex;
  gap: 0.75rem;
`;

interface ShareLinksProps {
  shareUrl: string;
}

const ShareLinks: React.FC<ShareLinksProps> = ({ shareUrl }) => {
  return (
    <ShareContainer>
      <Share>Share</Share>
      <Links>
        <IconContainer>
          <LinkedinShareButton url={shareUrl}>
            <FontAwesomeIcon icon={faLinkedinIn} />
          </LinkedinShareButton>
        </IconContainer>
        <IconContainer>
          <TwitterShareButton url={shareUrl}>
            <FontAwesomeIcon icon={faXTwitter} />
          </TwitterShareButton>
        </IconContainer>
        <IconContainer>
          <FacebookShareButton url={shareUrl}>
            <FontAwesomeIcon icon={faFacebookF} />
          </FacebookShareButton>
        </IconContainer>
      </Links>
    </ShareContainer>
  );
};

export default ShareLinks;
